export default __webpack_public_path__ + "static/media/WonderEats-Project.32871cd1.PNG";